import { HostResponseCodeDtoToEntity } from "src/app/features/HostResponseCode/services/mappers/HostResponseCodeDtoToEntity";
import type { HostResponseCodeDto } from "src/app/features/HostResponseCode/types/HostResponseCodeDto";
import type { HostResponseCodeEntity } from "src/app/features/HostResponseCode/types/HostResponseCodeEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const HostResponseCodeTableDtoMapper = (
    input: Readonly<ResourcePageDto<HostResponseCodeDto>>,
): ResourcePageEntity<HostResponseCodeEntity> => {
    return {
        list: input.list ? input.list.map(HostResponseCodeDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
